import React from 'react';

const StatusBadge = ({ 
  status, 
  variant = 'default', // 'default', 'dot', 'pill'
  size = 'sm' // 'xs', 'sm', 'md'
}) => {
  const getStatusColor = (status) => {
    const normalizedStatus = status?.toLowerCase();
    
    // Check for partial matches first (for complex status messages)
    if (normalizedStatus?.includes('failed') || normalizedStatus?.includes('error')) {
      return 'bg-red-100 text-red-800 border-red-200';
    }
    if (normalizedStatus?.includes('success') || normalizedStatus?.includes('completed') || normalizedStatus?.includes('connected')) {
      return 'bg-green-100 text-green-800 border-green-200';
    }
    if (normalizedStatus?.includes('running') || normalizedStatus?.includes('testing')) {
      return 'bg-blue-100 text-blue-800 border-blue-200';
    }
    
    // Exact matches for simple status values
    switch (normalizedStatus) {
      case 'active':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'inactive':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      case 'archived':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'warning':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'syncing':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getSizeClasses = (size) => {
    switch (size) {
      case 'xs':
        return 'px-1.5 py-0.5 text-xs';
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'md':
        return 'px-3 py-1.5 text-sm';
      default:
        return 'px-2 py-1 text-xs';
    }
  };

  const getVariantClasses = (variant) => {
    switch (variant) {
      case 'dot':
        return 'flex items-center space-x-1';
      case 'pill':
        return 'rounded-full';
      default:
        return 'rounded';
    }
  };

  const colorClasses = getStatusColor(status);
  const sizeClasses = getSizeClasses(size);
  const variantClasses = getVariantClasses(variant);

  if (variant === 'dot') {
    return (
      <span className={`inline-flex items-center space-x-1 ${sizeClasses} font-medium ${colorClasses} ${variantClasses}`}>
        <span className={`w-1.5 h-1.5 rounded-full ${colorClasses.includes('green') ? 'bg-green-400' : 
          colorClasses.includes('red') ? 'bg-red-400' : 
          colorClasses.includes('yellow') ? 'bg-yellow-400' :
          colorClasses.includes('blue') ? 'bg-blue-400' :
          colorClasses.includes('purple') ? 'bg-purple-400' :
          colorClasses.includes('orange') ? 'bg-orange-400' : 'bg-gray-400'}`}></span>
        <span>{status}</span>
      </span>
    );
  }

  return (
    <span className={`inline-block ${sizeClasses} font-medium border ${colorClasses} ${variantClasses}`}>
      {status}
    </span>
  );
};

export default StatusBadge;